/**
 * Enable/disable endpoints (listing, site, boondock) answer HTTP 200 with
 * `{ success: false, message }` when the server's publish checks refuse, one
 * reason per line. Treat that as the refusal it is, not a success.
 */
export function refusal(result: unknown): string | null {
  const r = result as { success?: unknown; message?: unknown } | null | undefined;
  if (!r || r.success !== false) return null;
  const message = typeof r.message === 'string' ? r.message.trim() : '';
  return message || 'The server refused without saying why.';
}

/** A success that carries news worth showing, e.g. disabling a listing's last site also unpublished it. */
export function sideEffect(result: unknown): string | null {
  const r = result as { success?: unknown; message?: unknown; listingDisabled?: unknown } | null | undefined;
  return r && r.success !== false && r.listingDisabled && typeof r.message === 'string' && r.message.trim()
    ? r.message.trim()
    : null;
}

/** An HTTP error's message for a toast. */
export function errorMessage(e: unknown): string {
  const err = e as { error?: { message?: string | string[] }; message?: string };
  const msg = err?.error?.message ?? err?.message ?? 'unknown error';
  return Array.isArray(msg) ? msg.join(', ') : msg;
}
